import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { DropzoneArea } from "material-ui-dropzone";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTimePicker from "../../../components/KPTimePicker";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import { uploadFile, uploadMultiFile } from "../../../reducer/file/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { insertSolution, updateSolution } from "../../../reducer/solution/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";

function SolutionInsertModal(props) {
  const { inserting, setInserting } = props;

  const [files, setFiles] = useState([]);
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [values, setValues] = useState({ purposeId: 3 });
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);

  // Tự gán bản thân vào danh sách tác giả
  useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInSolution: "main",
          statusInProject: "K",
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  // Bỏ KPI bỏ luôn contract
  useEffect(() => {
    if (!values?.profileIdForKpi) handleChangeForm("contractIdForKpi", null);
  }, [values?.profileIdForKpi]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ssZ") : null;
  };

  const handleChangeForm = (name, value) => {
    setValues({ ...values, [name]: value });
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    }
    if (name === "purposeId") {
      setValues({
        ...values,
        purposeId: value,
        profileIdForKpi: null,
        contractIdForKpi: null,
      });
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInSolution: "main",
      statusInProject: "K",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);

    const temp = profileList.filter((e, id) => id !== index);
    setProfileList([...temp]);
  };

  const handleSubmit = (e) => {
    // check title, numOfOwner, numOfMember
    if (!values?.title) {
      setHelperText(true);
      return;
    }
    if (!values?.numOfOwner) {
      setHelperText(true);
      return;
    }
    if (!values?.numOfMember) {
      setHelperText(true);
      return;
    }

    setInserting(false);
    const d = new Date();

    props
      .insertSolution(props.profile?.id, {
        ...values,
        dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
        solutionProfile: profileList,
        issueAt: dateFormat(values?.issueAt),
        acceptedDay: dateFormat(values?.acceptedDay),
        submissionDay: dateFormat(values?.submissionDay),
      })
      .then((response) => {
        if (response.success && files.length > 0) {
          props
            .uploadFile(response.data.id, "solution", files)
            .then((responseUpload) => {
              if (responseUpload.success)
                props.updateSolution(response.data.id, {
                  ...response.data,
                  fileUrl: responseUpload.data,
                });
            })
            .catch();
        }
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      })
      .catch();
    setValues(null);
    setProfileList([]);
  };

  const handleClose = () => {
    setValues(null);
    setProfileList([]);
    setInserting(false);
  };

  const getNoteByType = () => {
    return "Upload file minh chứng giải pháp hữu ích";
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === timeResearchYear)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type?.includes("solution")
  // );

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === timeResearchYear)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type?.includes("solution"));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth="md"
      open={inserting}
      onClose={handleClose}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h5" style={{ marginRight: 16 }}>
              Thêm giải pháp hữu ích
            </Typography>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              style={{ marginRight: 8, padding: "8px 24px", fontSize: "15px" }}
            >
              Huỷ
            </Button>
            <Button
              variant="contained"
              color="primary"
              // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
              disabled={
                (values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                (values?.purposeId === 99999999 && !values?.profileIdForReward)
              }
              onClick={handleSubmit}
              style={{ padding: "8px 24px", fontSize: "15px" }}
            >
              Xác nhận
            </Button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ display: "flex", padding: 0, height: "calc(100vh - 64px)", overflow: "hidden" }}>
        <div style={{ width: "60%", padding: "16px 24px", overflowY: "auto", borderRight: "1px solid #e0e0e0" }}>
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Tên giải pháp"
                value={values?.title || ""}
                required
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Tên giải pháp không được để trống" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                required
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng đồng sở hữu"
                value={values?.numOfOwner || ""}
                error={helperText && !values?.numOfOwner}
                helperText={helperText && !values?.numOfOwner ? "Số lượng đồng sở hữu không được để trống" : ""}
                onChange={(event) => handleChangeForm("numOfOwner", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      values={values?.isPhenikaa}
                      onChange={(event) => {
                        handleChangeForm("isPhenikaa", event.target.checked);
                      }}
                    />
                  }
                  label="Trường Đại học VinUni là Cơ quan chủ trì"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <TextField
                rows={2}
                fullWidth
                multiline
                size="small"
                variant="outlined"
                label="Nhóm tác giả"
                value={values?.authorTeam || ""}
                onChange={(event) => handleChangeForm("authorTeam", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng thành viên tham gia"
                value={values?.numOfMember || ""}
                error={helperText && !values?.numOfMember}
                helperText={
                  helperText && !values?.numOfMember ? "Số lượng thành viên tham gia không được để trống" : ""
                }
                onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={6}>
              <KPTimePicker
                fullWidth
                label="Ngày cấp bằng"
                value={values?.issueAt || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("issueAt", newValue)}
              />
              {/* <TextField
                fullWidth
                size='small'
                type='date'
                variant='outlined'
                label='Ngày cấp bằng'
                value={values?.issueAt || 0}
                InputLabelProps={{ shrink: true }}
                onChange={(event) => handleChangeForm('issueAt', event.target.value)}
              /> */}
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Cơ sở cấp"
                variant="outlined"
                value={values?.issueBy || ""}
                onChange={(event) => handleChangeForm("issueBy", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                label="Ngày nộp đơn"
                value={values?.submissionDay || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("submissionDay", newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                label="Ngày chấp nhận đơn"
                value={values?.acceptedDay || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("acceptedDay", newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                label="Số (Identification number)"
                variant="outlined"
                value={values?.identificationNumber || ""}
                onChange={(event) => handleChangeForm("identificationNumber", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Số lượng trang"
                variant="outlined"
                value={values?.pageNumber || ""}
                onChange={(event) => handleChangeForm("pageNumber", parseInt(event.target.value))}
              />
            </Grid>
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Điểm GS-PGS"
                variant="outlined"
                value={values?.score?.toString() || ""}
                onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
              />
            </Grid> */}
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.description}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {values?.purposeId === 5 && (
              <>
                <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                    error={false}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description}`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null}>Chưa có dữ liệu</MenuItem>
                    )}
                  </TextField>
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  {/* [VinUni] Bố cục thành viên gọn 2 dòng: dòng 1 (Thành viên 4 + Mã 4 + Đơn vị 4), dòng 2 (Vai trò + Trạng thái + [KPI/Thưởng] + Xoá) */}
                  <Grid item xs={4}>
                    <Autocomplete
                      disableClearable
                      options={profileListFromProps}
                      getOptionLabel={(option) => option.name}
                      value={
                        profileListFromProps?.find((profile) => profile.id === e.profileId) || profileListFromProps[0]
                      }
                      onChange={(event, profile) => {
                        if (profileList[index]?.profileId === values?.profileIdForKpi)
                          handleChangeForm("profileIdForKpi", null);
                        handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small" label="Thành viên" variant="outlined" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      disabled
                      variant="outlined"
                      label="Mã viên chức"
                      value={profileListFromProps?.find((profile) => profile.id === e.profileId)?.code || ""}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      disabled
                      variant="outlined"
                      label="Đơn vị"
                      value={
                        profileListFromProps?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                          ?.department?.name || ""
                      }
                    />
                  </Grid>
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInSolution-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò được giao
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInSolution-label"
                        value={e?.roleInSolution || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInSolution", event.target.value)}
                      >
                        <option value="main">Tác giả chính</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="statusInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Trạng thái
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="statusInProject-label"
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
          {values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 && (
            <div style={{ marginTop: 16 }}>
              <EmploymentContractTable
                contract={detail}
                contractList={contractList}
                kpiIdForKpi={values?.kpiIdForKpi}
                contractIdForKpi={values?.contractIdForKpi}
                setDetail={setDetail}
                values={values}
                setValues={setValues}
                handleChangeForm={handleChangeForm}
              />
              <EmploymentContractDetailTable kpi={detail} />
            </div>
          )}
        </div>
        <div style={{ width: "40%", padding: "16px 24px", overflowY: "auto", backgroundColor: "#fafafa" }}>
          <Typography variant="h6" style={{ marginBottom: 16, fontWeight: 600 }}>
            Upload file minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {getNoteByType()}
          </div>
          <DropzoneArea
            onChange={(newFiles) => {
              if (newFiles.length > 0) {
                setFiles(newFiles);
              }
            }}
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewGridProps={{ container: { spacing: 1, direction: "row" } }}
            previewText="File đã chọn:"
            filesLimit={1}
            maxFileSize={50000000}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  yearFilter: select(state, "timeResearchInformationReducer", "yearFilter"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  fileUrl: select(state, "fileReducer", "fileUrl"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadFile: (id, type, file) => dispatch(uploadFile(id, type, file)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertSolution: (profileId, payload) => dispatch(insertSolution(profileId, payload)),
  updateSolution: (profileId, payload) => dispatch(updateSolution(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(SolutionInsertModal));

